/**
 * Taken from ts-essentials
 *
 * https://github.com/ts-essentials/ts-essentials/tree/master/lib/functions/unreachable-case-error
 */
export class UnreachableCaseError extends Error {
  /**
   * This error is thrown when a `never` type is reached in a switch
   * statement or similar. This provides both a compile-time error
   * and a runtime error.
   */
  constructor(val: never) {
    super(`Unreachable case: ${JSON.stringify(val)}`);
  }
}
